import { Button } from '@nazka/nazka.mapframe.components';
import {
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
} from '@fortawesome/pro-light-svg-icons';

import { useTranslation } from '@utils/i18n/i18n.consumers';

import './datapanel-toggle.styl';

function getIcon(expanded, isDesktop) {
  if (expanded) {
    return isDesktop ? faChevronLeft : faChevronDown;
  }

  return isDesktop ? faChevronRight : faChevronUp;
}

function DatapanelToggle({
  className = '',
  buttonClassName = '',
  expanded,
  onToggle,
  variant,
}) {
  const { t } = useTranslation();
  const isDesktop = variant === 'desktop';
  const icon = getIcon(expanded, isDesktop);

  return (
    <div className={`datapanel-toggle datapanel-toggle--${variant} ${className}`}>
      <span>{t(expanded ? 'Close' : 'Open')}</span>
      <Button
        icon={icon}
        onClick={onToggle}
        layout="outlined"
        css={{
          borderRadius: '50%',
        }}
        hover={false}
        className={buttonClassName}
      />
    </div>
  );
}

export default DatapanelToggle;
